// extracted by mini-css-extract-plugin
module.exports = {"Stats":"Macros_Stats__1Mfdl","Ingredient":"Macros_Ingredient__1Y5WG","Table":"Macros_Table__14Lz9"};